import { Injectable } from '@angular/core';
import { map, withLatestFrom } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DepotActionTypes, InitUnloadAtDepot } from '../actions';
import * as appStore from '@appstore/*';
import { OverviewState } from '../registration';
import { ensureTourStopTrackingStarted } from '../utils';
import { ConfirmationService } from '../../../core/services/confirmation.service';
import { ComponentGeneratorService } from '../../../core/services/component-generator.service';

@Injectable()
export class DepotEffects {
  constructor(
    private actions$: Actions,
    private store: Store<OverviewState | appStore.AppState>,
    // componentGenerator & confirmations are used in the `ensureTourStopTrackingStarted` call
    private componentGenerator: ComponentGeneratorService,
    private confirmations: ConfirmationService
  ) {}

  initUnloadAtDepot$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepotActionTypes.INIT_UNLOAD_AT_DEPOT),
      map((action: InitUnloadAtDepot) => action.payload),
      ensureTourStopTrackingStarted(this),
      withLatestFrom(this.store.select(appStore.getCurrentRouterUrl)),
      map(([_payload, currentRouterUrl]) => {
        return new appStore.RouterNavigate({
          path: [currentRouterUrl, 'set-raster-location']
        });
      })
    )
  );
}
